<template>
  <div class="m-wrap-document">
    <div class="box-inline">
      <Button type="primary" :disabled="disabled" @click="docModel = true">选择文案</Button>
      <span class="span-num"
        ><ins>{{ value.length }}</ins
        >/{{ max }}</span
      >
      <Poptip v-if="value.length && !disabled" confirm title="确定要清空？" class="pop-btn" @on-ok="$emit('on-clear')">
        <Icon type="ios-trash-outline" size="22" color="#ff2200" />
        <span>清空全部</span>
      </Poptip>
    </div>
    <div v-if="len" class="m-caption">
      <dl v-for="(caption, i) in value" :key="caption.docId" class="m-caption-item">
        <input-len
          v-model="caption.docContent"
          placeholder="请输入创意标题（12~60个字符,中文占两个字符）"
          width="608"
          :max="60"
          :words="words"
          readonly
        />
        <Icon type="ios-trash-outline" size="22" color="#ff2200" v-if="!disabled" @click="$emit('on-delete', i)" />
        <Icon type="md-create" size="22" color="#5cadff" v-if="caption.opId !== 1 && !disabled" @click="editOpen(caption, i)" />
      </dl>
    </div>
    <div v-else class="c-nodata">
      <Icon type="ios-filing-outline" size="92" color="#efefef" />
      <span>请选择文案</span>
    </div>

    <document v-model="docModel" :open-id="openId" @on-cancel="docModel = false" @on-select="save" />
    <Modal v-model="editModel" title="编辑文案内容" :transfer="false" class-name="edit-doc" @on-ok="editDocument">
      <Spin size="large" fix v-if="saving"></Spin>
      <div class="c-caption">
        <span class="c-caption-num m-muted">
          <ins :class="warnClass">{{ warnlen }}</ins
          >/60
        </span>
        <input
          ref="title"
          class="c-caption-input"
          v-model="editDocContent"
          placeholder="请输入创意标题（12~60个字符,中文占两个字符）"
          @keyup="clearEvent"
          @keydown="keyEvent"
          @click="handleClick"
        />
      </div>
      <div class="c-words">
        <span>动态词插入：</span>
        <a v-for="item in words" :key="item.creative_word_id" @click="setWord(item)">{{ item.name }}</a>
        <Button type="text" @click="clearWord" style="color: #ff4400; margin-left: 12px">清除动态词</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import { isArray, isEmpty, timeout, getByteLen } from '@/common/js/utils'
import InputLen from '@/components/input/input-len.vue'
import Document from '@/views/create/toutiao_local/components/idea/document/document.vue'

import { savePlanDocument } from '@/api/manage.model'
export default {
  name: 'DocSelect',
  components: { Document, InputLen },
  computed: {
    len() {
      return this.value.length
    },
    warnlen() {
      let num = 0
      const val = this.editDocContent
      const regexp = /({[\u4e00-\u9fa5]{2,}})/g
      if (!isEmpty(val)) {
        const values = val.match(regexp)
        num += getByteLen(val)
        if (isArray(values)) {
          values.forEach((ret) => {
            ret === '{节日}' && (num += 4)
            ret === '{日期}' && (num += 6)
            ret === '{地点}' && (num += 2)
          })
        }
      }
      return num
    },
    warnClass() {
      return this.len > this.maxLen ? 'm-num-warn' : ''
    },
    dynPos() {
      const regexp = /{[\u4e00-\u9fa5]{2,}}/g
      const values = this.editDocContent.match(regexp)
      if (isArray(values)) {
        return values
          .filter((ret) => this.words.map((met) => `{${met.name}}`).includes(ret))
          .map((m) => {
            const min = this.editDocContent.indexOf(m)
            return [min, min + m.length]
          })
      } else return []
    }
  },
  props: {
    value: {
      type: Array
    },
    openId: {
      type: [Number, String]
    },
    max: {
      type: Number
    },
    words: {
      type: Array
    },
    disabled: {
      type: Boolean
    }
  },
  methods: {
    save(meta) {
      this.$emit('on-select', meta)
      timeout(0).then(() => {
        this.docModel = false
      })
    },
    editOpen(row, i) {
      const { docId, docContent, creativeWordIdsJson } = row
      const suffix = docContent.indexOf('{')
      const lastSuffix = docContent.lastIndexOf('{')
      this.index = i
      this.editDocId = docId
      this.editDocContent = docContent
      this.creative_word_ids = creativeWordIdsJson.map((ret, i) => {
        const filterWord = this.words.filter((met) => met.creative_word_id === ret).pop()
        return Object.assign({}, filterWord, { cut: i ? lastSuffix : suffix })
      })
      this.editModel = true
    },
    // 提交修改
    editDocument() {
      this.saving = true
      savePlanDocument({
        docId: this.editDocId,
        creativeWordIds: JSON.stringify(this.creative_word_ids.map((ret) => ret.creative_word_id)),
        docContent: this.editDocContent
      }).then((data) => {
        this.saving = false
        if (data) this.$emit('on-update', { item: data, index: this.index })
      })
    },
    // 刷新标题
    reflashTitle(title, words, direction = 'left') {
      let newTitle
      if (words.length >= 2) {
        title = title.replace(/{[\u4e00-\u9fa5]{2,}}/g, '')
        const prefix = title.substring(0, words[0].cut)
        const midfix = direction === 'left' ? title.substring(words[0].cut, words[1].cut) : title.substring(words[0].cut, words[1].cut - 4)
        const suffix = direction === 'left' ? title.substring(words[1].cut) : title.substring(words[1].cut - 4)
        newTitle = `${prefix}{${words[0].name}}${midfix}{${words[1].name}}${suffix}`
      } else if (words.length) {
        title = title.replace(/{[\u4e00-\u9fa5]{2,}}/g, '')
        const prefix = title.substring(0, words[0].cut)
        const suffix = title.substring(words[0].cut)
        newTitle = `${prefix}{${words[0].name}}${suffix}`
      } else {
        newTitle = title.replace(/{[\u4e00-\u9fa5]{2,}}/g, '')
      }
      return newTitle
    },
    // 插入动态词
    setWord(item, index) {
      let direction
      const len = this.creative_word_ids.length
      const { selectionStart, _value } = this.$refs.title
      const trend = Object.assign({}, item, { cut: selectionStart })
      const suffix = _value.indexOf('{')
      if (suffix > -1) {
        // 方向添加
        const lastSuffix = _value.lastIndexOf('{')
        if (selectionStart <= suffix) direction = 'left'
        else if (selectionStart <= lastSuffix) direction = 'right'
        else direction = 'plus-right'
      }
      if (len >= 2) {
        if (direction === 'left') {
          this.creative_word_ids.shift()
          this.creative_word_ids.unshift(trend)
        } else if (direction === 'right' || direction === 'plus-right') {
          if (direction === 'plus-right') trend.cut -= 4
          this.creative_word_ids.pop()
          this.creative_word_ids.push(trend)
        }
      } else if (len && direction === 'left') {
        this.creative_word_ids.unshift(trend)
      } else {
        this.creative_word_ids.push(trend)
      }
      this.editDocContent = this.reflashTitle(this.editDocContent, this.creative_word_ids, direction)
    },
    // 清空动态词
    clearWord() {
      this.creative_word_ids = []
      this.editDocContent = this.editDocContent.replace(/{[\u4e00-\u9fa5]{2,}}/g, '')
    },
    // 退格删除动态词
    delTrend(order) {
      if (isArray(this.creative_word_ids) && this.creative_word_ids.length > 1 && order === 0) {
        // 2动态词 变1时，且是删除了左边动态词
        const title = JSON.parse(JSON.stringify(this.editDocContent))
        this.creative_word_ids[1].cut = title.indexOf(`{${this.creative_word_ids[1].name}}`)
      }
      this.creative_word_ids.splice(order, 1)
      this.editDocContent = this.reflashTitle(this.editDocContent, this.creative_word_ids)
    },
    clearEvent(e) {
      if ([8, 46].includes(e.keyCode) && isArray(this.dynPos) && !this.dynPos.length) {
        this.clearWord()
      }
    },
    // 动态词 键盘监听
    keyEvent(e) {
      const input = this.$refs.title
      const { selectionStart } = input
      const getMax = (num, min, max) => {
        if (num === min) return max
        else return num
      }
      const getMin = (num, min, max) => {
        if (num === max) return min
        else return num
      }
      const getDelMax = (num, min, max) => {
        if (num === max) return [min, max]
        else return num
      }
      const getDelMin = (num, min, max) => {
        if (num === min) return [min, max]
        else return num
      }
      const getMid = (num, min, max) => num > min && num < max
      if (window.event.shiftKey && (e.keyCode === 219 || e.keyCode === 221)) {
        window.event.returnValue = false
        this.$Notice.error({ title: '系统提示', desc: '创意标题禁止使用 ‘{’ 和 ‘}’ 。' })
        return
      } else if (window.event.ctrlKey && e.keyCode === 90) {
        window.event.returnValue = false
        this.$Notice.error({ title: '系统提示', desc: '创意标题不允许使用撤回！' })
        return
      }
      if (isArray(this.dynPos) && !this.dynPos.length) return
      if (e.keyCode === 37) {
        // left arrow
        let val
        this.dynPos.some((ret) => {
          const [min, max] = ret
          val = getMin(selectionStart, min, max)
          return min === val
        })
        if (selectionStart !== val) window.event.returnValue = false
        input.selectionStart = input.selectionEnd = val
      } else if (e.keyCode === 39) {
        // right arrow
        let val
        this.dynPos.some((ret) => {
          const [min, max] = ret
          val = getMax(selectionStart, min, max)
          return selectionStart !== max && max === val
        })
        if (selectionStart !== val) window.event.returnValue = false
        input.selectionStart = input.selectionEnd = val
      } else if (e.keyCode === 8) {
        // backspace
        let val
        let order
        const lock = this.dynPos.some((ret) => {
          const [min, max] = ret
          return getMid(selectionStart, min, max)
        })
        if (lock) window.event.returnValue = false
        this.dynPos.some((ret, i) => {
          const [min, max] = ret
          val = getDelMax(selectionStart, min, max)
          order = i
          return isArray(val)
        })
        if (isArray(val)) {
          // 发事件出去删除动态词
          const [min, max] = val
          input.selectionStart = min
          input.selectionEnd = max
          timeout(300).then(() => {
            this.delTrend(order)
          })
        }
      } else if (e.keyCode === 46) {
        // delete
        let val
        let order
        const lock = this.dynPos.some((ret) => {
          const [min, max] = ret
          return getMid(selectionStart, min, max)
        })
        if (lock) window.event.returnValue = false
        this.dynPos.some((ret, i) => {
          const [min, max] = ret
          val = getDelMin(selectionStart, min, max)
          order = i
          return isArray(val)
        })
        if (isArray(val)) {
          const [min, max] = val
          input.selectionStart = min
          input.selectionEnd = max
          timeout(300).then(() => {
            this.delTrend(order)
          })
        }
      }
    },
    handleClick() {
      const input = this.$refs.title
      const { selectionStart } = input
      if (isArray(this.dynPos) && this.dynPos.length) {
        let val
        const getMid = (num, min, max) => {
          if (num > min && num < max) return max
          else return num
        }
        this.dynPos.some((ret) => {
          const [min, max] = ret
          val = getMid(selectionStart, min, max)
          return max === val
        })
        input.selectionStart = input.selectionEnd = val
      }
    }
  },
  data() {
    return {
      saving: null,
      docModel: null,
      editModel: null,
      editDocId: 0,
      editDocContent: '',
      creative_word_ids: []
    }
  }
}
</script>
<style lang="scss" scoped>
.m-wrap-document {
  position: relative;

  .box-inline {
    display: inline-block;
    line-height: 32px;

    > * {
      display: inline-block;
      vertical-align: middle;
    }

    .span-num,
    .span-sub {
      font-size: 15px;
      padding-left: 26px;
      padding-right: 26px;
      margin: 0;
    }

    .span-sub {
      color: #999;
      padding-left: 10px;
    }

    .span-idea-sub {
      padding-left: 10px;
      padding-right: 10px;
    }

    .pop-btn {
      margin-left: 26px;
      font-size: 14px;
      cursor: pointer;

      i {
        display: inline-block;
        vertical-align: middle;
        margin-right: 4px;
      }
    }
  }

  .m-caption {
    overflow-y: auto;
    scrollbar-width: thin;
    -webkit-overflow-scrolling: touch;

    max-width: 720px;
    max-height: 280px;
    padding: 22px 48px 0 0;

    .m-caption-item {
      display: flex;
      align-items: center;
      margin-bottom: 4px;

      i {
        cursor: pointer;
        margin-left: 10px;
      }
    }
  }

  .c-nodata {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .ivu-icon {
      display: inline-block;
    }

    span {
      color: #bebebe;
      font-size: 14px;
    }
  }

  .edit-doc {
    position: relative;
  }

  .c-caption {
    border: solid 1px #ddd;

    .c-caption-input {
      display: inline-block;
      width: 438px;
      height: 30px;
      padding-left: 12px;
    }

    .m-num-warn {
      color: #ff6600;
    }

    .m-muted {
      width: 42px;
      color: #666;
      line-height: 32px;
      font-size: 85%;
      float: right;
      padding-right: 12px;
      text-align: right;
    }
  }

  .c-words {
    padding: 5px 0;
    line-height: 20px;

    a {
      padding: 0 5px;
      white-space: nowrap;
    }
  }
}
</style>
